import { createContext } from 'react';

export const NodeIdContext = createContext<string | undefined>(undefined);
